import script from "./BasicScan.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicScan.vue?vue&type=script&setup=true&lang=js"

import "./BasicScan.vue?vue&type=style&index=0&id=5c5b7e6f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5b7e6f"]])

export default __exports__